import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {toasterActions} from '@homeaway/react-toaster';
import TripBoard from '../TripBoard/TripBoard';
import './TripBoardButton.less';
import {setTripboardTranslations} from '../../actions/index';
import {ButtonIcon} from '@homeaway/react-buttons';

class TripBoardButton extends Component {
    static propTypes = {
        adultsCount: PropTypes.number,
        childrenCount: PropTypes.number,
        endDate: PropTypes.string,
        hasBorder: PropTypes.bool,
        isDisabled: PropTypes.bool,
        isHearted: PropTypes.bool,
        isLoading: PropTypes.bool,
        listingId: PropTypes.string.isRequired,
        tripBoards: PropTypes.object, // eslint-disable-line react/forbid-prop-types
        getTripboards: PropTypes.func,
        onHeart: PropTypes.func,
        onUnheart: PropTypes.func,
        petIncluded: PropTypes.bool,
        position: PropTypes.oneOf(['bottom', 'left', 'right', 'right-auto']),
        siteName: PropTypes.string,
        startDate: PropTypes.string,
        thumbnailUrl: PropTypes.string,
        type: PropTypes.oneOf(['default', 'outline']),
        rating: PropTypes.number,
        headline: PropTypes.string,
        reviewCount: PropTypes.number,
        abacus: PropTypes.object, // eslint-disable-line
        useNativeEventListener: PropTypes.bool
    };

    static defaultProps = {
        adultsCount: null,
        childrenCount: null,
        hasBorder: false,
        isDisabled: false,
        isHearted: false,
        isLoading: true,
        onHeart: () => {},
        onUnheart: () => {},
        tripBoards: {boards: []},
        getTripboards: () => {},
        petIncluded: null,
        position: 'right',
        siteName: null,
        thumbnailUrl: null,
        type: 'default',
        rating: 0,
        headline: '',
        reviewCount: 0,
        abacus: {},
        useNativeEventListener: false
    };

    constructor(props) {
        super(props);
        this.refButton = null;
        this.stabHit = null;
    }

    componentDidMount() {
        const props = this.props;
        const {siteName, createToast, getTripboards} = props;

        this.setUpTripBoard(siteName, createToast, getTripboards);
        if (
            typeof window !== 'undefined' &&
            Object.keys(this.props.translations).length === 0 &&
            window.tripboardConfig &&
            window.tripboardConfig.translations
        ) {
            this.props.setTripboardTranslations({translations: window.tripboardConfig.translations});
        }

        if (this.props.useNativeEventListener && this.refButton) {
            this.refButton.addEventListener('click', this.toggle);
        }
    }

    componentWillUnmount() {
        if (this.props.useNativeEventListener && this.refButton) {
            this.refButton.removeEventListener('click', this.toggle);
        }
    }

    setUpTripBoard(siteName, createToast, getTripboards) {
        TripBoard.setSitename(siteName);
        TripBoard.setCreateToast(createToast);
        TripBoard.setGetTripboards(getTripboards);
        TripBoard.setVisibilityListener();
    }

    toggle = () => {
        const {isHearted, removeFromBoard, listingId} = this.props;
        if (isHearted) {
            TripBoard.remove(removeFromBoard, listingId);
        } else {
            TripBoard.open(this);
        }
    };

    render() {
        const {hasBorder, isDisabled, position, type, tripboards, translations, loading} = this.props;
        const boards = (tripboards && tripboards.boards) || [];
        const translationKey =
            !loading && boards.length > 0 ? 'tripboards.modal.add.to' : 'tripboards.modal.create.new.list.copy';
        const ariaLabel = translations[translationKey];

        const buttonClasses = classnames({
            'react-trip-board-button': true,
            'react-trip-board-button__position-bottom': position === 'bottom',
            'react-trip-board-button__position-right': position === 'right',
            'react-trip-board-button__outline': type === 'outline'
        });

        const iconClass = classnames('react-trip-board-button__heart-core__heart-icon', {
            unhearted: !this.props.isHearted,
            isDisabled,
            'loading-anim-2': loading
        });

        const iconClassBg = classnames('react-trip-board-button__heart-core__heart-icon', {
            unhearted: !this.props.isHearted,
            'react-trip-board-button__heart-core-bg': true,
            'loading-anim-bg-2': loading
        });

        return (
            <div ref={(c) => (this.refButton = c)}>
                <ButtonIcon
                    noBorder={!hasBorder}
                    size={'sm'}
                    circle
                    className={buttonClasses}
                    label={ariaLabel}
                    disabled={isDisabled}
                    onClick={this.toggle}
                >
                    <svg
                        data-id="SVG_HEART__16"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            className={iconClassBg}
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8 3.98S9.13 2 11.5 2C13.57 2 15 3.7 15 5.73c0 2.86-2.98 4.6-7 8.27-4.02-3.67-7-5.41-7-8.27C1 3.7 2.43 2 4.5 2 6.88 2 8 3.98 8 3.98z"
                        />
                        <path
                            className={iconClass}
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8 3.98S9.13 2 11.5 2C13.57 2 15 3.7 15 5.73c0 2.86-2.98 4.6-7 8.27-4.02-3.67-7-5.41-7-8.27C1 3.7 2.43 2 4.5 2 6.88 2 8 3.98 8 3.98z"
                        />
                    </svg>
                </ButtonIcon>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    const {translations} = state.tripboardButton;
    const boards = (props.tripboards && props.tripboards.boards) || [];
    let isHearted = false;
    for (let index = 0; index < boards.length; index++) {
        const tripboard = boards[index];
        const listingRefs = tripboard.listingRefs || [];
        if (listingRefs.includes(props.listingId)) {
            isHearted = true;
            break;
        }
    }

    return {
        isHearted,
        translations
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            createToast: toasterActions.createToast,
            setTripboardTranslations
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TripBoardButton);
